'use client'

import { usePathname, useSearchParams } from 'next/navigation'
import { useEffect, useState } from 'react'

import { StyledInterstitial } from '../../../components/chrome/Interstitial/Interstitial'

export const Interstitial = () => {
  const pathname = usePathname()
  const searchparams = useSearchParams()
  const [isVisible, setIsVisisble] = useState(false)
  useEffect(() => {
    setIsVisisble(false)
    const clickHandler = (event: MouseEvent) => {
      // Ignore command/control + click
      if (event.metaKey || event.ctrlKey) return
      const target = event.target
      if (
        typeof HTMLElement !== 'undefined' &&
        (target instanceof HTMLElement || target instanceof SVGElement)
      ) {
        const wrappingAnchor = target.closest('a')
        const href = wrappingAnchor?.getAttribute('href')
        //Don't show the interstitial if we're just switching fragments
        const hrefWithoutHash = href?.split('#')[0] ?? ''
        const hrefTarget = wrappingAnchor?.getAttribute('target') ?? ''
        if (
          href &&
          !href.includes(window.location.pathname) &&
          !pathname?.includes(hrefWithoutHash) &&
          hrefTarget.toLowerCase() !== '_blank'
        ) {
          setIsVisisble(true)
        }
      }
    }

    window.addEventListener('click', clickHandler)
    return () => {
      window.removeEventListener('click', clickHandler)
    }
  }, [pathname, searchparams])

  return isVisible ? <StyledInterstitial /> : null
}
